module.exports = __webpack_public_path__ + "img/wechat-qrcode-7.0105c90d.png";